var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2408 0.511661C10.5136 -0.0636199 9.48635 -0.0636199 8.75914 0.511661L1.24848 6.45319C0.529229 7.02218 0.109741 7.8889 0.109741 8.806V16.8897C0.109741 18.5466 1.45288 19.8897 3.10974 19.8897H9.99998H16.8902C18.5471 19.8897 19.8902 18.5466 19.8902 16.8897V8.806C19.8902 7.8889 19.4707 7.02218 18.7515 6.45319L11.2408 0.511661ZM2.48932 8.02173L9.99998 2.0802L17.5106 8.02173C17.7504 8.2114 17.8902 8.5003 17.8902 8.806V16.8897C17.8902 17.442 17.4425 17.8897 16.8902 17.8897H13.9512V13.2269C13.9512 12.6746 13.5035 12.2269 12.9512 12.2269H7.04877C6.49648 12.2269 6.04877 12.6746 6.04877 13.2269V17.8897H3.10974C2.55746 17.8897 2.10974 17.442 2.10974 16.8897V8.806C2.10974 8.5003 2.24957 8.2114 2.48932 8.02173ZM8.04877 17.8415V14.2269H11.9512V17.8415H8.04877Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSvg);
export default __webpack_public_path__ + "static/media/homeSvg.966dfaf5.svg";
export { ForwardRef as ReactComponent };